import { Outlet } from "react-router-dom";
import CommonLayout from "../../pages/Layouts/CommonLayout";
import usePodcast from "./usePodcast";

const Podcast = () => {
  const { drawerMenu } = usePodcast();

  return (
    <CommonLayout drawerMenu={drawerMenu}>
      <Outlet />
    </CommonLayout>
  );
};

export default Podcast;